import { PaymentMethods } from 'types/beneficiaries'
import { ContactFiatInstrumentFormKeys } from '../schemas/contactFiatInstrumentSchema'

export const CURRENCY_DETAILS_FIELDS: ContactFiatInstrumentFormKeys[] = [
  'currency',
  'paymentMethods',
]

export const BASIC_FIELDS: ContactFiatInstrumentFormKeys[] = [
  'entityType',
  'description',
  'businessName',
  'firstName',
  'lastName',
]

export const BENEFICIARY_ADDRESS_FIELDS: ContactFiatInstrumentFormKeys[] = [
  'beneficiaryAddressLine1',
  'beneficiaryAddressLine2',
  'beneficiaryCity',
  'beneficiaryRegion',
  'beneficiaryRegionCode',
  'beneficiaryPostCode',
  'beneficiaryCountryCode',
]

export const BASIC_BANK_ACCOUNT_FIELDS: ContactFiatInstrumentFormKeys[] = [
  'accountNumber',
  'accountNumberConfirm',
  'bankCode',
  'swiftCode',
  'accountType',
]
export const BANK_ADDRESS_FIELDS: ContactFiatInstrumentFormKeys[] = [
  'bankName',
  'bankCountryName',
  'bankAddressLine1',
  'bankAddressLine2',
  'bankCity',
  'bankRegion',
  'bankPostCode',
  'bankCountryCode',
]
export const INTERMEDIARY_BANK_FIELDS: ContactFiatInstrumentFormKeys[] = [
  'intermediaryBankCode',
  'intermediaryBankSwiftCode',
  'intermediaryBankName',
  'intermediaryBankAddressLine1',
  'intermediaryBankAddressLine2',
  'intermediaryBankCity',
  'intermediaryBankRegion',
  'intermediaryBankPostCode',
  'intermediaryBankCountryCode',
]

export const EEA_COUNTRY_CODES = [
  'AT',
  'BE',
  'BG',
  'HR',
  'CY',
  'CZ',
  'DK',
  'EE',
  'FI',
  'FR',
  'DE',
  'GR',
  'HU',
  'IS',
  'IE',
  'IT',
  'LV',
  'LI',
  'LT',
  'LU',
  'MT',
  'NL',
  'NO',
  'PL',
  'PT',
  'RO',
  'SK',
  'SI',
  'ES',
  'SE',
]

export const USD_LOCAL_ONLY_PAYMENT_METHODS: string[] = [
  PaymentMethods.ACH,
  PaymentMethods.FEDWIRE,
  PaymentMethods.FEDNOW,
  PaymentMethods.CRNOW,
  PaymentMethods.CUBIX,
  PaymentMethods.RTP,
]
